import React, { FC } from 'react';

import { ComponentWithLegacyClassNameProps } from '../../util/ComponentWithLegacyClassName/props';

import { getClassNames } from './MaxZoom.styles.legacy';

export interface MaxZoomProps extends ComponentWithLegacyClassNameProps {
  readonly maxZoom: number;
}

export const MaxZoom: FC<MaxZoomProps> = ({ maxZoom, children, className }) => {
  const { zoomContainer } = getClassNames(maxZoom, className);

  return <div className={zoomContainer}>{children}</div>;
};
